import TeacherPostReviewDetailStore from './TeacherPostReviewDetailStore';
import TeacherPostReviewDetailContainer from './TeacherPostReviewDetailContainer';
import { registerStore } from 'utils/registerStore';
import { rootStore } from 'stores/root/RootStore';
import interfaceBridge from 'utils/interfaceBridge';

// step 1 store 생성-등록, root가 필요한 경우 import 해서 사용
registerStore(
  'TeacherPostReviewDetailStore',
  new TeacherPostReviewDetailStore(rootStore),
);

// step 2 props type 선언
export type TeacherPostReviewDetailPropsT = {
  scope: 'mine' | 'inbox';
};

// step 3 page component 선언
function TeacherPostReviewDetail({ scope }: TeacherPostReviewDetailPropsT) {
  // step 5 상단 네비게이션 바 작동 선언
  interfaceBridge.setTitle('발행 전 글 보기');
  interfaceBridge.setButtonIcon('left', 'back');
  interfaceBridge.setBtnEventHandler({
    left: () => {
      interfaceBridge.back();
    },
  });

  return <TeacherPostReviewDetailContainer scope={scope} />;
}
export default TeacherPostReviewDetail;
